import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import { getOrder } from 'services/api'
import {
  getColoring,
  isGlobalContextOrderValid,
  mapOrderValues,
} from '../orderHelper'
import { ContextOrder } from 'types/order'

import { useStateManager } from 'components/context/StateManager'

function useOrder(): {
  isLoading: boolean
  order: ContextOrder
} {
  const router = useRouter()
  const [isLoading, setLoading] = useState(true)
  const [state, setState] = useStateManager()
  const { order } = state

  useEffect(() => {
    if (isGlobalContextOrderValid(state.order)) {
      setLoading(false)

      return
    }

    const loadOrder = async () => {
      const response = await getOrder()

      const mappedOrder = mapOrderValues(response)
      const { email, coloring, chance, custom_data } = response

      const urlColoring = getColoring(router)

      setState({
        ...state,
        order: mappedOrder,
        coloring: urlColoring.utm_source ? urlColoring : coloring,
        email,
        chance,
        customData: custom_data,
      })
      setLoading(false)
    }

    loadOrder()
  }, [state, setState, router])

  return { isLoading, order }
}

export default useOrder
